import React, { useState, useEffect } from "react";
import { BeatLoader } from "react-spinners";
import { getProduct } from "../../api/app";
import Footer from "../../components/layout/Footer";
import { useDispatch, useSelector } from "react-redux";
import { encodeQueryParameter } from "../../utils/url";
import cogoToast from "cogo-toast";
import { ADD_TO_CART } from "../../stores/cart";
import SEO from "../../components/layout/Seo";
import ReactImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { formatAmount } from "../../utils/formatAmount";
import { FaCcVisa, FaCcMastercard } from "react-icons/fa";

const productData = {
  sub_images: [
    {
      uri: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80",
    },
    {
      uri: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8&auto=format&fit=crop&w=1080&q=80",
    },
    {
      uri: "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=980&q=80h",
    },
    {
      uri: "https://images.unsplash.com/photo-1437719417032-8595fd9e9dc6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=980&q=80",
    },
    {
      uri: "https://images.unsplash.com/photo-1581889470536-467bdbe30cd0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=720&q=80",
    },
  ],
};
const ProductDesc = (props) => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [commentText, setCommentText] = useState("");
  const [commentsList, setCommentsList] = useState([]);
  console.log("product", product);

  const id = props.match.params.id;

  const carts = useSelector((state) => state.cart.products);

  useEffect(() => {
    window.scrollTo(0, 0);
    getProduct(id).then((response) => {
      if (!response.error) {
        setProduct(response.book);
        setLoading(false);
      }
    });
  }, []);

  const closeModal = () => {
    setShowModal(false);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const handleAddComment = () => {
    if (commentText.trim()) {
      setCommentsList([
        ...commentsList,
        { text: commentText, date: new Date() },
      ]);
      setCommentText("");
      cogoToast.success("Comment added!", { hideAfter: 3 });
    } else {
      cogoToast.error("Please write a comment before submitting.", {
        hideAfter: 3,
      });
    }
  };

  const handleRating = (value) => {
    setRating(value);
  };
  const onAddCart = (product) => {
    let productItem = carts.find((result) => result._id === product._id);

    if (productItem !== undefined) {
      cogoToast.error("You already added this item to the cart basket.", {
        hideAfter: 3,
      });
      return false;
    }

    dispatch(
      ADD_TO_CART({
        products: [
          {
            _id: product._id,
            name: product.name,
            img: product.image_uri,
            ori_price: product.amount,
            description: product.description,
            price: product.amount,
            units: 1,
            quantity: 1,
          },
        ],
      })
    );

    cogoToast.success("Item has been added to the card.", { hideAfter: 3 });
  };
  const images = [
    {
      original: product?.image_uri,
      thumbnail: product?.image_uri,
      description: product?.name,
    },
    ...(product?.media || [])
      .map((media) => {
        const uri = media.file?.uri;
        const type = media.file?.type;

        // Check for image or video MIME type
        if (type?.startsWith("image")) {
          return {
            original: uri,
            thumbnail: uri,
            type: "image",
          };
        } else if (type?.startsWith("video")) {
          return {
            original: uri,
            thumbnail: product?.image_uri,
            embedUrl: uri,
            renderItem: () => (
              <video controls width="100%" height="100%" autoPlay>
                <source src={uri} type={type} />
                Your browser does not support the video tag.
              </video>
            ),
            type: "video",
          };
        } else {
          return null; // skip unsupported types
        }
      })
      .filter(Boolean), // Remove nulls
  ];

  return (
    <div>
      <SEO title={product?.title} description={product?.description} />
      {loading ? (
        <div className="h-screen flex item-center justify-center">
          <div className="loader">
            <BeatLoader color="#003074" size={20} />
          </div>
        </div>
      ) : (
        <div className="container mx-auto p-4">
          <div className="flex flex-1 items-center space-x-4">
            <a href="#">
              <img
                src="assets/images/cover.jpg"
                className="bg-gray-200 border border-white rounded-full w-10 h-10"
              />
            </a>
            <div className="flex-1 font-semibold capitalize">
              <a href="#" className="text-black">
                {" "}
                ZStudy for STEM{" "}
              </a>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 grid-rows-2 gap-1">
            {/* Column 1, Row 1 */}
            <div className="p-4 h-full" style={{ height: "100%" }}>
              <ReactImageGallery
                items={images}
                showThumbnails={true}
                thumbnailPosition="left"
                showPlayButton={false}
                autoPlay={false}
                slideDuration={2000}
                renderItem={(item) => (
                  <div className="custom-gallery-image">
                    <img
                      src={item.original}
                      alt={item.description}
                      className="w-full border-2 border-black-200 rounded-lg"
                      style={{ height: "400px", width: "500px" }}
                    />
                  </div>
                )}
              />

              <div>
                <div className="mt-4">
                  {/* Display Comments */}
                  <h3 className="text-lg font-semibold">Comments</h3>
                  <div>
                    {commentsList.length > 0 ? (
                      commentsList.map((comment, index) => (
                        <div key={index} className="mt-2 p-2 border-b">
                          <p>{comment.text}</p>
                          <span className="text-sm text-gray-500">
                            {new Date(comment.date).toLocaleString()}
                          </span>
                        </div>
                      ))
                    ) : (
                      <p>No comments yet.</p>
                    )}
                  </div>
                  {/* Add Comment Form */}
                  <div className="mt-4">
                    <textarea
                      type="text"
                      placeholder="Add a comment..."
                      value={commentText}
                      onChange={(e) => setCommentText(e.target.value)}
                      className="w-full p-3 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <button
                      type="submit"
                      className="bg-blue-600 flex flex-1  font-semibold h-10 items-center justify-center px-4 rounded-md text-white mt-4"
                      onClick={handleAddComment}
                    >
                      Add Comment
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Column 2, Row 1 */}
            <div className="col-span-1 h-32 ">
              <div className="text-2xl font-semibold pt-2"> {product.name}</div>
              <br />
              <hr />
              <br />
              <p> {product.description}</p>
              <div className="mt-4">
                {/* Star Rating */}
                <div className="flex items-center">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      onClick={() => handleRating(star)}
                      className={`cursor-pointer ${
                        star <= rating
                          ? "text-yellow-500"
                          : "text-gray-300 text-lg"
                      }`}
                    >
                      ★
                    </span>
                  ))}
                </div>
                <p className="mt-2">Rating: {rating} stars</p>
              </div>
              <div className="top-3 text-black-700 text-lg ">
                {formatAmount(product.amount)}
              </div>
              <div className="flex space-x-3 items-center text-sm md:pt-3">
                {product.in_stock ? (
                  <div className="font-semibold text-green-500"> In-Stock</div>
                ) : (
                  <div className="font-semibold text-red-500">
                    {" "}
                    Out-of-Stock
                  </div>
                )}
              </div>
              <br />
              <hr />
              <br />

              <div className="grid grid-cols-1 gap-4 mb-5">
                <button
                  className="bg-blue-600 flex flex-1 font-semibold h-10 items-center justify-center px-4 rounded-md text-white"
                  onClick={openModal}
                >
                  {/* <a
                    href={`#/purchase/${encodeQueryParameter(
                      Object.assign({ product: product, type: "product" })
                    )}`}
                  > */}
                  Buy Now
                  {/* </a> */}
                </button>
                {product.in_stock ? (
                  <button
                    onClick={onAddCart.bind(null, product)}
                    className="bg-blue-300 flex flex-1 font-semibold h-10 items-center justify-center px-4 rounded-md text-white"
                  >
                    Add to Cart
                  </button>
                ) : (
                  <button
                    className="bg-red-600 flex flex-1 font-semibold h-10 items-center justify-center px-4 rounded-md text-white"
                    disabled
                  >
                    Out of Stock
                  </button>
                )}
                <a
                  href="tel:+260967754716"
                  className="bg-gray-200 flex flex-1 font-semibold h-10 items-center justify-center px-4 rounded-md"
                >
                  Contact seller
                </a>
                <div className="flex items-center space-x-8 mt-5">
                  {/* Shipping label */}
                  <div className="text-xlg font-semibold">Shipping:</div>

                  {/* Delivery description */}
                  <div className="text-xlg">
                    k 100.00 Shipping outside lusaka. See details for shipping
                    Located in Lusaka.
                  </div>
                </div>

                <div className="flex items-center space-x-8 mt-5">
                  {/* Delivery label */}
                  <div className="text-xlg font-semibold">Delivery:</div>

                  {/* Delivery description */}
                  <div className="text-xlg">
                    Estimated between Tue and Thur, Free delivery within Lusaka
                  </div>
                </div>
                <div className="flex items-center space-x-8 mt-5">
                  {/* Returnslabel */}
                  <div className="text-xlg font-semibold">Returns:</div>

                  {/* Delivery description */}
                  <div className="text-xlg">
                    30 days returns. Buyer pays for return shipping. If you are
                    outside lusaka, it will be deducted from your refund amount.
                  </div>
                </div>
                {/* Payment Methods Section */}
                <div className="flex items-center space-x-4 mt-5">
                  {/* Payments label */}
                  <div className="text-xlg font-semibold">Payments:</div>

                  {/* Payment Icons */}
                  <div className="grid grid-cols-6 gap-3 mt-3">
                    {/* American Express */}
                    <div className="flex items-center justify-center bg-blue-100 h-10 w-16 rounded-lg">
                      <img
                        src="/assets/images/AmericaX.png"
                        alt="logo"
                        className="h-7 rounded-sm"
                      />
                    </div>

                    {/* Visa */}
                    <div className="flex items-center justify-center bg-blue-100 h-10 w-16 rounded-lg">
                      <FaCcVisa className="text-white-700 text-3xl" />
                    </div>

                    {/* MasterCard */}
                    <div className="flex items-center justify-center bg-blue-100 h-10 w-16 rounded-lg">
                      <FaCcMastercard className="text-red-700 text-3xl" />
                    </div>

                    {/* Airtel */}
                    <div className="flex items-center justify-center bg-blue-100 h-10 w-16 rounded-lg">
                      <img
                        src="/assets/images/airtel.jpg"
                        alt="logo"
                        className="h-7 rounded-sm"
                      />
                    </div>

                    {/* Mtn money */}
                    <div className="flex items-center justify-center bg-blue-100 h-10 w-16 rounded-lg">
                      <img
                        src="/assets/images/mtn.png"
                        alt="logo"
                        className="h-7 rounded-sm"
                      />
                    </div>

                    {/* Zamtel */}
                    <div className="flex items-center justify-center bg-blue-100 h-10 w-16 rounded-lg">
                      <img
                        src="/assets/images/zamtel.png"
                        alt="logo"
                        className="h-7 rounded-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* modal */}

      {showModal && (
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50 px-4"
          onClick={closeModal}
        >
          <div
            className="bg-white w-full max-w-md md:max-w-xl lg:w-1/3 rounded-lg shadow-lg p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center border-b pb-2 mb-4">
              <h5 className="text-xl font-semibold">Product Details</h5>
              <button
                type="button"
                className="text-xl font-bold"
                onClick={closeModal}
              >
                &times;
              </button>
            </div>

            {/* Modal Body */}
            <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-4">
              <img
                src={product.image_uri}
                alt=""
                className="w-full sm:w-48 h-auto object-contain rounded-md"
              />

              <div className="text-center sm:text-left">
                <div className="text-2xl font-semibold">{product.name}</div>
                <p>{product.description}</p>
              </div>
            </div>

            {/* Modal Action */}
            <button className="bg-blue-600 font-semibold h-10 items-center justify-center px-4 rounded-md text-white w-full">
              Sign in to Check out
            </button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default ProductDesc;
